import { render, staticRenderFns } from "./PovosComunidadesTradicionais.vue?vue&type=template&id=4cd95630&lang=pug"
import script from "./PovosComunidadesTradicionais.vue?vue&type=script&lang=js"
export * from "./PovosComunidadesTradicionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports